import { css } from '@emotion/core'
import { colors, measures, font } from 'styles/variables'

const { unit } = measures

export const overlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: ${4 * unit}px;
`

export const modal = css`
  background-color: ${colors.grays.gray7};
  border-radius: ${3 * unit}px;
  padding: ${4 * unit}px ${3 * unit}px ${3 * unit}px;
  width: 100%;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const content = css`
  margin-bottom: ${4 * unit}px;
`

export const title = css`
  color: ${colors.white12};
  font-size: 16px;
  font-weight: ${font.weight.bold};
  margin: 0 0 ${2 * unit}px 0;
  text-align: center;
  display: block;
  width: 100%;
`

export const message = css`
  color: ${colors.grays.gray2};
  font-size: 12px;
  font-weight: ${font.weight.normal};
  margin: 0;
  line-height: 1.4;
  text-align: center;
  display: block;
  width: 100%;
`

export const buttonContainer = css`
  display: flex;
  gap: ${3 * unit}px;
  width: 100%;
`

export const noButton = css`
  flex: 1;
  background-color: transparent !important;
  border: 1px solid ${colors.greens.green2} !important;
  border-radius: 50px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  
  &:hover {
    background-color: rgba(78, 194, 98, 0.1) !important;
  }
`

export const noButtonText = css`
  color: ${colors.greens.green2} !important;
  font-size: 14px !important;
  font-weight: ${font.weight.medium} !important;
  margin: 0 !important;
`

export const yesButton = css`
  flex: 1;
  background-color: ${colors.greens.green2} !important;
  border: none !important;
  border-radius: 50px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  
  &:hover {
    background-color: ${colors.greens.green3} !important;
  }
`

export const yesButtonText = css`
  color: black !important;
  font-size: 14px !important;
  font-weight: ${font.weight.medium} !important;
  margin: 0 !important;
` 